// Payment methods (cards) list
export const LIST_PAYMENT_METHODS_REQUEST = 'LIST_PAYMENT_METHODS_REQUEST';
export const LIST_PAYMENT_METHODS_SUCCESS = 'LIST_PAYMENT_METHODS_SUCCESS';
export const LIST_PAYMENT_METHODS_FAILURE = 'LIST_PAYMENT_METHODS_FAILURE';
export const LIST_PAYMENT_METHODS_RESET = 'LIST_PAYMENT_METHODS_RESET';

// Generic action reducer covers: ensureCustomer, createSetupIntent,
// setDefault, remove, cancelTrialAutoCharge, updateTrialPlan, purchaseWithSavedCard
export const BILLING_ACTION_REQUEST = 'BILLING_ACTION_REQUEST';
export const BILLING_ACTION_SUCCESS = 'BILLING_ACTION_SUCCESS';
export const BILLING_ACTION_FAILURE = 'BILLING_ACTION_FAILURE';
export const BILLING_ACTION_RESET = 'BILLING_ACTION_RESET';
